import { Component } from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import '../styles/FeaturedSticker.css'
import popularBadgeImage from '../img/home/popular_badge.png';
import rising_badge from '../img/home/rising_badge.png'
import medal_bonus from '../img/home/medal_bonus.png'
class FeaturedSticker extends Component{

  render(){
    const {cartonData, stickerListData, createdAt, credit } = this.props;
    return(
      <div>
        <div className="featured-thumbnail-container">
          <img src={cartonData.thumbnail} className="featured-package-img" alt="pack thumbnail"/>
          <div className="featured-thumbnail-wrapper">
            <div className="featured-thumbnail-info" style={{height: credit ? 150 : 120}}>
              <p className="featured-thumbnail-name">{cartonData.cartonName}</p>
              <p className="featured-thumbnail-nickname">{cartonData.authorNickname}</p>
              {
                this.props.credit ? 
                  <p className="featured-thumbnail-text">
                    <FormattedHTMLMessage
                      id={'Home.featured.popular'}
                      defaultMessage={'current revenue<br/>of stickers'}
                    />
                  </p> : null
              }
              <p className="featured-thumbnail-text-extrapoints"style={this.props.credit ? {} :{marginTop:'30px'}}>
                <FormattedHTMLMessage
                  id={'Home.featured.popular.extraPoints'}
                  defaultMessage={'Got the extra points'}
                />
              </p>
            </div>
            {
              this.props.credit ? 
                <div className="featured-thumbnail-credit-box" style={createdAt > new Date('2019/2/12') ? {backgroundImage: `url(${popularBadgeImage})`} : undefined}>
                  <div className="featured-thumbnail-credit">${this.props.credit}
                  </div>
                </div>
              :
              <div className="featured-thumbnail-rising-bonus">
              <img src={createdAt > new Date('2019/2/12') ? rising_badge : medal_bonus} alt=""/>
            </div>
            }
          </div>
        </div>
        
        <span className="featured-sticker-container">
          {
            stickerListData.map((stickerUrl,index)=>{
              return(
                <span key={index}>
                  <img src={stickerUrl} className="featured-sticker-img" alt="featured sticker"/>
                </span>
              )
            })
          }
        </span>
      </div>
    )
  }

}
export default FeaturedSticker;
